import { useGet } from '../../HttpClient';
import { GetAllCategoriesModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";
 
export function useMemoCategories(includeExpired) {
  const get = useGet(true, pillarCode);
  const getMemoCategories = (): Promise<GetAllCategoriesModel> =>
    get(`${referenceDataBaseUrl}/memo-categories/?includeExpired=${includeExpired}`);
  return useQueryWithErrorHandling({
    queryKey: ['get-memo-categories'],
    queryFn: async () => await getMemoCategories(),
  });
}

export function useRefreshMemoCategories() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['get-memo-categories'] });
}
